/** An SMS provider has no page of its own: installing it and its settings are sheets over the Integrations page. */
export function installSmsIntegrationPath(providerKey: string): string {
  return `/integrations/sms/new?provider=${encodeURIComponent(providerKey)}`;
}

export function smsIntegrationPath(id: string): string {
  return `/integrations/sms/${id}`;
}
